app.service('basketUtils', function (console, modal, loading, cookie, orderConfig, orderUtils, message) {
	function calculateCart(focusParams) {
		console.log('PRZELICZENIE KOSZYKA');
		skipValidation();
		incBacks();

		var voucher = $.trim($('#voucher-input').val());
		if (voucher.length > 0 && !/^[0-9a-zA-Z._-]+$/.test(voucher)) {
			modal.alert('Nieprawidłowe znaki w kodzie rabatowym');
			return false;
		}
		orderUtils.send('SAVE', true, focusParams);
	}
	function incBacks() {
		$('#f_backs').val(($('#f_backs').val() / 1) + 1);
	}
	function skipValidation() {
		$('.js-delivery-type').ignore(true);
	}

	return {
		calculateCart,
		incBacks,
		skipValidation
	};
});
